import "./repo.a5e9c946.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecaa2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecaa2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lsboS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9e50e5a44fb11e0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ArrowRight", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
]);

});

parcelRegister("8dk79", function(module, exports) {

$parcel$export(module.exports, "default", () => $5faf23ec0b8e3e8e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $5faf23ec0b8e3e8e$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Sparkles", [
    [
        "path",
        {
            d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
            key: "4pj2yx"
        }
    ],
    [
        "path",
        {
            d: "M20 3v4",
            key: "1olli1"
        }
    ],
    [
        "path",
        {
            d: "M22 5h-4",
            key: "1gvqau"
        }
    ],
    [
        "path",
        {
            d: "M4 17v2",
            key: "vumght"
        }
    ],
    [
        "path",
        {
            d: "M5 18H3",
            key: "zchphs"
        }
    ]
]);

});

parcelRegister("gRgf3", function(module, exports) {

$parcel$export(module.exports, "PageHero", () => $5405cac3ced8ac70$export$4b2976b57d220ac6);

var $ayMG0 = parcelRequire("ayMG0");
function $5405cac3ced8ac70$export$4b2976b57d220ac6({ kicker: kicker, title: title, lead: lead, image: image, imageAlt: imageAlt = '', children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "page-hero",
        children: [
            image && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-hero-media",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: image,
                        alt: imageAlt
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "page-hero-overlay"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-shell page-hero-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "eyebrow eyebrow-light reveal is-visible",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true"
                            }),
                            " ",
                            kicker
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "reveal is-visible",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "page-hero-lead reveal is-visible",
                        children: lead
                    }),
                    children && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "page-hero-extra reveal is-visible",
                        children: children
                    })
                ]
            })
        ]
    });
}

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $lsboS = parcelRequire("lsboS");
var $03hdr = parcelRequire("03hdr");
var $voOPz = parcelRequire("voOPz");
var $7RdtG = parcelRequire("7RdtG");/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $562322ea18d3146f$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Radio", [
    [
        "path",
        {
            d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9",
            key: "1vaf9d"
        }
    ],
    [
        "path",
        {
            d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5",
            key: "u1ii0m"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "2",
            key: "1c9p78"
        }
    ],
    [
        "path",
        {
            d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5",
            key: "1j5fej"
        }
    ],
    [
        "path",
        {
            d: "M19.1 4.9C23 8.8 23 15.1 19.1 19",
            key: "10b0cb"
        }
    ]
]);


var $8dk79 = parcelRequire("8dk79");/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $b7d23bd78f9484d8$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Video", [
    [
        "path",
        {
            d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
            key: "ftymec"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "6",
            width: "14",
            height: "12",
            rx: "2",
            key: "158x01"
        }
    ]
]);



var $clpju = parcelRequire("clpju");

var $5xqgC = parcelRequire("5xqgC");

var $gRgf3 = parcelRequire("gRgf3");

var $3ua1s = parcelRequire("3ua1s");

var $gb7Gf = parcelRequire("gb7Gf");
const $0b313a45154f57bf$var$liveTimes = (0, $gb7Gf.services).filter((service)=>service.title === 'Servicio general');
const $0b313a45154f57bf$var$verses = [
    {
        text: "L\xe1mpara es a mis pies tu palabra, y lumbrera a mi camino.",
        reference: 'Salmos 119:105'
    },
    {
        text: "Por nada est\xe9is afanosos\u2026 y la paz de Dios, que sobrepasa todo entendimiento, guardar\xe1 vuestros corazones.",
        reference: 'Filipenses 4:6-7'
    },
    {
        text: 'No temas, porque yo estoy contigo; no desmayes, porque yo soy tu Dios que te esfuerzo.',
        reference: "Isa\xedas 41:10"
    }
];
function $0b313a45154f57bf$export$44d823c33581a1e1() {
    (0, $3ua1s.useReveal)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5xqgC.Layout), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gRgf3.PageHero), {
                kicker: "Mensajes",
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Palabra que ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                            children: "edifica"
                        }),
                        " el coraz\xf3n."
                    ]
                }),
                lead: "Cada semana compartimos un mensaje de fe y esperanza. Mira las transmisiones en vivo y los mensajes recientes en nuestro Facebook.",
                image: (0, $clpju.imgAdoracion),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                    className: "button button-gold",
                    href: (0, $gb7Gf.facebookUrl),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $voOPz.default), {
                            size: 18,
                            "aria-hidden": "true"
                        }),
                        " Ver mensajes en Facebook"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "section-space",
                "aria-labelledby": "live-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "section-heading reveal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "section-kicker",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                                " En vivo y en directo"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            id: "live-title",
                                            children: "Acomp\xe1\xf1anos desde donde est\xe9s."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Transmitimos nuestros servicios por Facebook. Con\xe9ctate, comenta y comparte el mensaje con alguien que lo necesite."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "live-layout",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "live-card reveal",
                                    href: (0, $gb7Gf.facebookUrl),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    "aria-label": "Ver las transmisiones en vivo de Tercer Cielo en Facebook",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "live-card-topline",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "live-badge",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $562322ea18d3146f$export$2e2bcd8739ae039), {
                                                            size: 17,
                                                            "aria-hidden": "true"
                                                        }),
                                                        " En vivo por Facebook"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                                    size: 22,
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "Transmisiones de los servicios"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "Mira los servicios completos, mensajes recientes y momentos de la casa."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: "live-schedule",
                                            children: $0b313a45154f57bf$var$liveTimes.map((service)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7d23bd78f9484d8$export$2e2bcd8739ae039), {
                                                            size: 17,
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            children: [
                                                                service.day,
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                    children: service.time
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, `${service.day}-${service.time}`))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "live-cta",
                                            children: [
                                                "Abrir Facebook ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                                    size: 18,
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "live-side",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                            className: "social-card social-card-instagram reveal",
                                            href: (0, $gb7Gf.instagramUrl),
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "social-card-icon",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7RdtG.default), {
                                                        size: 26,
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "Instagram"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Fragmentos, fotos y anuncios de la semana."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                                    size: 20,
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("figure", {
                                            className: "live-photo reveal",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (0, $clpju.imgCongregacionWide),
                                                    alt: "La congregaci\xf3n de Tercer Cielo reunida durante un servicio",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("figcaption", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8dk79.default), {
                                                            size: 16,
                                                            "aria-hidden": "true"
                                                        }),
                                                        " Momentos que marcan la casa"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "verses-section section-space",
                "aria-labelledby": "verses-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "section-heading reveal",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "section-kicker section-kicker-light",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                            " Palabra para hoy"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        id: "verses-title",
                                        children: "Lleva un vers\xedculo contigo."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "verses-grid",
                            children: $0b313a45154f57bf$var$verses.map((verse)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("blockquote", {
                                    className: "verse-card reveal",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            children: [
                                                "\u201C",
                                                verse.text,
                                                "\u201D"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("cite", {
                                            children: verse.reference
                                        })
                                    ]
                                }, verse.reference))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "cta-band",
                "aria-labelledby": "messages-cta-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell cta-band-inner reveal",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            id: "messages-cta-title",
                            children: "El mensaje se vive mejor en casa."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "Nada como estar presente: adoraci\xf3n, comuni\xf3n y oraci\xf3n."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cta-band-actions",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "button button-light",
                                    href: "/visita/",
                                    children: [
                                        "Planifica tu visita ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsboS.default), {
                                            size: 18,
                                            "aria-hidden": "true"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "button button-ghost",
                                    href: (0, $gb7Gf.facebookUrl),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        "S\xedguenos en Facebook ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                            size: 18,
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



const $7234f60fd101585a$var$container = document.getElementById('app');
(0, $aRPiL.createRoot)($7234f60fd101585a$var$container).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b313a45154f57bf$export$44d823c33581a1e1), {})
}));


//# sourceMappingURL=mensajes.5c0ad299.js.map
